import {downloadService} from '../_services'

export const download = {
  namespaced: true,
  actions: {
    xlsx ({dispatch, commit}) {
      downloadService.xlsx()
        .then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'TrackingData.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/_store/download.js